import { render, staticRenderFns } from "./otherUpload.vue?vue&type=template&id=7050ff07&scoped=true&"
import script from "./otherUpload.vue?vue&type=script&lang=ts&"
export * from "./otherUpload.vue?vue&type=script&lang=ts&"
import style0 from "./otherUpload.vue?vue&type=style&index=0&id=7050ff07&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7050ff07",
  null
  
)

export default component.exports